import { useState, useEffect } from "react";
import { isUserLoggedIn } from "./authUtils";

/**
 * Logged-out users must not see product prices, discounts, or cart totals.
 */
export const canViewPrices = () => isUserLoggedIn();

/**
 * Re-renders when login state changes (login, logout, same-tab).
 */
export function useCanViewPrices() {
  const [visible, setVisible] = useState(() => isUserLoggedIn());

  useEffect(() => {
    const sync = () => setVisible(isUserLoggedIn());
    window.addEventListener("wireoxAuthChanged", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("wireoxAuthChanged", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  return visible;
}
